import { render, staticRenderFns } from "./ListAllItems.vue?vue&type=template&id=8050f102&lang=pug&"
import script from "./ListAllItems.vue?vue&type=script&lang=ts&"
export * from "./ListAllItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports